import { applyMiddleware, compose, createStore, combineReducers } from 'redux'
import { createBrowserHistory } from 'history'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { firebase as fbConfig } from '../config/fb'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase'
import GeoFire from 'geofire'

export const history = createBrowserHistory()

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// Initialize Firebase instance
firebase.initializeApp(fbConfig)

// --------------------------
// Do some GeoFire stuff

var firebaseRef = firebase.database().ref('geoFire');
var geoFire = new GeoFire(firebaseRef);

// --------------------------
const rootReducer = combineReducers({
  firebase: firebaseReducer,
  geoFire: () => geoFire,
})
// --------------------------


const store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancer(
    reactReduxFirebase(firebase,
      {
        userProfile: 'users',
        enableLogging: false
      },
    ),
    applyMiddleware(
      routerMiddleware(history),
    ),
  ),
)

export default store



// WEBPACK FOOTER //
// ./src/redux/store.js